import {
  SiAngular,
  SiAuth0,
  SiBetterauth,
  SiClaude,
  SiClerk,
  SiCloudflare,
  SiCodeblocks,
  SiCypress,
  SiDjango,
  SiDocker,
  SiDrizzle,
  SiExpress,
  SiFastapi,
  SiFirebase,
  SiGithub,
  SiGraphql,
  SiHono,
  SiInstagram,
  SiJest,
  SiKubernetes,
  SiMongodb,
  SiMysql,
  SiNextdotjs,
  SiOpenai,
  SiOpentelemetry,
  SiPostgresql,
  SiPosthog,
  SiPrisma,
  SiPython,
  SiReact,
  SiRedis,
  SiResend,
  SiRubyonrails,
  SiSentry,
  SiShadcnui,
  SiStripe,
  SiSupabase,
  SiTailwindcss,
  SiTiktok,
  SiTrpc,
  SiTurborepo,
  SiTypescript,
  SiVercel,
  SiVite,
  SiVuedotjs,
  SiWebpack,
  SiWindsurf,
  SiX,
  SiZod,
} from '@icons-pack/react-simple-icons'
import * as React from 'react'

export interface IconProps extends React.SVGProps<SVGSVGElement> {}

// Core Tech Icons
export const ReactIcon = React.memo(function ReactIcon(props: IconProps) {
  return <SiReact {...props} />
})

export const TypeScriptIcon = React.memo(function TypeScriptIcon(props: IconProps) {
  return <SiTypescript {...props} />
})

export const ViteIcon = React.memo(function ViteIcon(props: IconProps) {
  return <SiVite {...props} />
})

export const DrizzleIcon = React.memo(function DrizzleIcon(props: IconProps) {
  return <SiDrizzle {...props} />
})

export const TurborepoIcon = React.memo(function TurborepoIcon(props: IconProps) {
  return <SiTurborepo {...props} />
})

export const TailwindIcon = React.memo(function TailwindIcon(props: IconProps) {
  return <SiTailwindcss {...props} />
})

export const ShadcnIcon = React.memo(function ShadcnIcon(props: IconProps) {
  return <SiShadcnui {...props} />
})

export const TrpcIcon = React.memo(function TrpcIcon(props: IconProps) {
  return <SiTrpc {...props} />
})

export const ZodIcon = React.memo(function ZodIcon(props: IconProps) {
  return <SiZod {...props} />
})

export const HonoIcon = React.memo(function HonoIcon(props: IconProps) {
  return <SiHono {...props} />
})

export const SentryIcon = React.memo(function SentryIcon(props: IconProps) {
  return <SiSentry {...props} />
})

export const OpenTelemetryIcon = React.memo(function OpenTelemetryIcon(props: IconProps) {
  return <SiOpentelemetry {...props} />
})

// Company/Service Icons
export const CloudflareIcon = React.memo(function CloudflareIcon(props: IconProps) {
  return <SiCloudflare {...props} />
})

export const PostHogIcon = React.memo(function PostHogIcon(props: IconProps) {
  return <SiPosthog {...props} />
})

export const ClaudeIcon = React.memo(function ClaudeIcon(props: IconProps) {
  return <SiClaude {...props} />
})

export const OpenAIIcon = React.memo(function OpenAIIcon(props: IconProps) {
  return <SiOpenai {...props} />
})

export const WindsurfIcon = React.memo(function WindsurfIcon(props: IconProps) {
  return <SiWindsurf {...props} />
})

export const BetterAuthIcon = React.memo(function BetterAuthIcon(props: IconProps) {
  return <SiBetterauth {...props} />
})

export const CursorIcon = React.memo(function CursorIcon(props: IconProps) {
  return <SiCodeblocks {...props} />
})

export const XIcon = React.memo(function XIcon(props: IconProps) {
  return <SiX {...props} />
})

export const GithubIcon = React.memo(function GithubIcon(props: IconProps) {
  return <SiGithub {...props} />
})

export const InstagramIcon = React.memo(function InstagramIcon(props: IconProps) {
  return <SiInstagram {...props} />
})

export const TikTokIcon = React.memo(function TikTokIcon(props: IconProps) {
  return <SiTiktok {...props} />
})

export const VueIcon = React.memo(function VueIcon(props: IconProps) {
  return <SiVuedotjs {...props} />
})

export const AngularIcon = React.memo(function AngularIcon(props: IconProps) {
  return <SiAngular {...props} />
})

export const NextJsIcon = React.memo(function NextJsIcon(props: IconProps) {
  return <SiNextdotjs {...props} />
})

export const WebPackIcon = React.memo(function WebPackIcon(props: IconProps) {
  return <SiWebpack {...props} />
})

export const ExpressIcon = React.memo(function ExpressIcon(props: IconProps) {
  return <SiExpress {...props} />
})

export const FastApiIcon = React.memo(function FastApiIcon(props: IconProps) {
  return <SiFastapi {...props} />
})

export const DjangoIcon = React.memo(function DjangoIcon(props: IconProps) {
  return <SiDjango {...props} />
})

export const RailsIcon = React.memo(function RailsIcon(props: IconProps) {
  return <SiRubyonrails {...props} />
})

export const PostgresqlIcon = React.memo(function PostgresqlIcon(props: IconProps) {
  return <SiPostgresql {...props} />
})

export const MongoDbIcon = React.memo(function MongoDbIcon(props: IconProps) {
  return <SiMongodb {...props} />
})

export const MySQLIcon = React.memo(function MySQLIcon(props: IconProps) {
  return <SiMysql {...props} />
})

export const RedisIcon = React.memo(function RedisIcon(props: IconProps) {
  return <SiRedis {...props} />
})

export const DockerIcon = React.memo(function DockerIcon(props: IconProps) {
  return <SiDocker {...props} />
})

export const KubernetesIcon = React.memo(function KubernetesIcon(props: IconProps) {
  return <SiKubernetes {...props} />
})
export const VercelIcon = React.memo(function VercelIcon(props: IconProps) {
  return <SiVercel {...props} />
})
export const SupabaseIcon = React.memo(function SupabaseIcon(props: IconProps) {
  return <SiSupabase {...props} />
})
export const FirebaseIcon = React.memo(function FirebaseIcon(props: IconProps) {
  return <SiFirebase {...props} />
})
export const StripeIcon = React.memo(function StripeIcon(props: IconProps) {
  return <SiStripe {...props} />
})

export const Auth0Icon = React.memo(function Auth0Icon(props: IconProps) {
  return <SiAuth0 {...props} />
})
export const ClerkIcon = React.memo(function ClerkIcon(props: IconProps) {
  return <SiClerk {...props} />
})
export const PrismaIcon = React.memo(function PrismaIcon(props: IconProps) {
  return <SiPrisma {...props} />
})
export const GraphQLIcon = React.memo(function GraphQLIcon(props: IconProps) {
  return <SiGraphql {...props} />
})
export const JestIcon = React.memo(function JestIcon(props: IconProps) {
  return <SiJest {...props} />
})
export const CypressIcon = React.memo(function CypressIcon(props: IconProps) {
  return <SiCypress {...props} />
})
export const PythonIcon = React.memo(function PythonIcon(props: IconProps) {
  return <SiPython {...props} />
})
export const ResendIcon = React.memo(function ResendIcon(props: IconProps) {
  return <SiResend {...props} />
})

// Flag Icons (using simple fallback icons since country flags aren't in simple-icons)
export const USAIcon = React.memo(function USAIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-label="USA" role="img" {...props}>
      <rect width="24" height="24" rx="2" fill="#1f2937" />
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontFamily="monospace">
        US
      </text>
    </svg>
  )
})

export const EUIcon = React.memo(function EUIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-label="EU" role="img" {...props}>
      <rect width="24" height="24" rx="2" fill="#1f2937" />
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontFamily="monospace">
        EU
      </text>
    </svg>
  )
})

export const INIcon = React.memo(function INIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-label="India" role="img" {...props}>
      <rect width="24" height="24" rx="2" fill="#1f2937" />
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontFamily="monospace">
        IN
      </text>
    </svg>
  )
})

export const AUIcon = React.memo(function AUIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-label="Australia" role="img" {...props}>
      <rect width="24" height="24" rx="2" fill="#1f2937" />
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontFamily="monospace">
        AU
      </text>
    </svg>
  )
})
